import { Link } from 'react-router'

interface Props {
  currentPage: number
  totalPages: number
  /** Query string (?…) of a page. */
  pageHref: (page: number) => string
}

/** Previous / next as real links (crawlable, work without JavaScript). */
export default function SearchPagination({ currentPage, totalPages, pageHref }: Props) {
  const button = 'flex h-11 items-center gap-1.5 rounded-xl border-2 border-qt-text px-4 text-sm font-bold hover:bg-qt-soft'

  return (
    <nav aria-label="Pagination" className="mt-10 flex items-center justify-between gap-4">
      {currentPage > 1 ? (
        <Link to={{ search: pageHref(currentPage - 1) }} rel="prev" className={button}>
          <span aria-hidden="true">←</span> Previous
        </Link>
      ) : (
        <span />
      )}
      <p className="text-sm font-bold text-qt-muted">
        Page {currentPage} of {totalPages}
      </p>
      {currentPage < totalPages ? (
        <Link to={{ search: pageHref(currentPage + 1) }} rel="next" className={button}>
          Next <span aria-hidden="true">→</span>
        </Link>
      ) : (
        <span />
      )}
    </nav>
  )
}
